import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'

// Styles
import classes from './History.scss'

// Actions
import { orderActions } from 'redux/actionCreators'

// Components
import { Heading } from 'components'

// Helpers
import _get from 'lodash.get'

const mapStateToProps = (state) => ({
  orders: _get(state, ['order', 'orders']) || [],
  reordering: _get(state, 'order.reorderAttempting') || false
})
const mapDispatchToProps = (dispatch) => ({
  attemptFindOrders: (payload) =>
    dispatch(orderActions.attemptFindOrders({
      ...payload,
      limit: 1000
    })),
  attemptReorder: (orderId) =>
    dispatch(orderActions.attemptReorder(orderId))
})

@connect(mapStateToProps, mapDispatchToProps)
class History extends Component {
  static propTypes = {
    orders: PropTypes.array.isRequired,
    attemptFindOrders: PropTypes.func.isRequired
  };

  componentDidMount () {
    window.objectFitImages()
  }

  componentWillMount () {
    this.props.attemptFindOrders()
  }

  _reorder = (orderId) =>
    this.props.attemptReorder(orderId);

  _renderDesktopRow = ({ orderId, checkedOutAt, paidStatus, deliveryStatus, invoicePath, docHash }, index) =>
    <tr key={orderId}>
      <td className='text-center'>{index + 1}</td>
      <td className='text-center'><a target='_blank' href={`/services/docs/${orderId}-summary${docHash ? `-${docHash}` : ''}.pdf`}>{orderId}</a></td>
      <td className='text-center'>{checkedOutAt}</td>
      <td className='text-center'>
        {invoicePath ? <a target='_blank' href={invoicePath}>Invoice</a> : '-'}
      </td>
      <td className='text-center'>
        {({
          pending: 'รอชำระเงิน',
          checking: 'รอเช็คสินค้า',
          credit: 'รอชำระ(เครดิต)',
          paid: 'ชำระเงินแล้ว',
          packaging: 'กำลังดำเนินการ',
          delivered: 'ส่งสินค้าแล้ว',
          canceled: 'ยกเลิก'
        })[paidStatus] || '-'}
      </td>
      <td className='text-center'>
        {({
          pending: 'รอชำระเงิน',
          checking: 'รอเช็คสินค้า',
          credit: 'ชำระเงินแล้ว',
          paid: 'ชำระเงินแล้ว',
          packaging: 'กำลังดำเนินการ',
          delivered: 'ส่งสินค้าแล้ว',
          canceled: 'ยกเลิก'
        })[deliveryStatus] || '-'}
      </td>
      <td className='text-center'>
        <div className={classes.button} onClick={() => this._reorder(orderId)}>
          <span>สั่งซื้อสินค้าอีกครั้ง</span>
        </div>
      </td>
    </tr>

  _renderMobileRow = ({ orderId, checkedOutAt, paidStatus, deliveryStatus, invoicePath, docHash }, index) =>
    <div key={orderId} className={classes.row}>
      <Col index={1}>{index + 1}</Col>
      <Col index={2}>
        <a target='_blank' href={`/services/docs/${orderId}-summary${docHash ? `-${docHash}` : ''}.pdf`}>{orderId}</a>
      </Col>
      <Col index={3}>
        {invoicePath ? <a target='_blank' href={invoicePath}>Invoice</a> : '-'}
      </Col>
      <Col index={4}>
        <label>วันที่สั่งซื้อ:</label>
        <div>{checkedOutAt}</div>
        <label>สถานะการชำระเงิน</label>
        <div>
          {({
            pending: 'รอชำระเงิน',
            checking: 'รอเช็คสินค้า',
            credit: 'รอชำระ(เครดิต)',
            paid: 'ชำระเงินแล้ว',
            packaging: 'กำลังดำเนินการ',
            delivered: 'ส่งสินค้าแล้ว',
            canceled: 'ยกเลิก'
          })[paidStatus] || '-'}
        </div>
        <label>สถานะการส่งสินค้า</label>
        <div>
          {({
            pending: 'รอชำระเงิน',
            checking: 'รอเช็คสินค้า',
            credit: 'ชำระเงินแล้ว',
            paid: 'ชำระเงินแล้ว',
            packaging: 'กำลังดำเนินการ',
            delivered: 'ส่งสินค้าแล้ว',
            canceled: 'ยกเลิก'
          })[deliveryStatus] || '-'}
        </div>
        <div className={classes.button} onClick={() => this._reorder(orderId)}>
          <span>สั่งซื้อสินค้าอีกครั้ง</span>
        </div>
      </Col>
    </div>

  render () {
    const { orders } = this.props
    return (
      <section className={classes.history}>
        <div className='desktop'>
          <Heading>รายการสั่งซื้อ</Heading>
          <table className='with-stripe'>
            <thead>
              <tr>
                <th>ลำดับ</th>
                <th>เลขที่ใบสั่งซื้อ</th>
                <th>วันที่สั่งซื้อ</th>
                <th>ใบส่งสินค้า</th>
                <th>สถานะการชำระเงิน</th>
                <th>สถานะการส่งสินค้า</th>
                <th />
              </tr>
            </thead>
            <tbody>{orders.map(this._renderDesktopRow)}</tbody>
          </table>
        </div>
        <div className='mobile'>
          <div className={classes.table}>
            <div className={classes.row}>
              <Col index={1}>ลำดับ</Col>
              <Col index={2}>เลขที่ใบสั่งซื้อ</Col>
              <Col index={3}>ใบส่งสินค้า</Col>
              <Col index={4}>รายละเอียด</Col>
            </div>
            {orders.map(this._renderMobileRow)}
          </div>
        </div>
      </section>
    )
  }
}

const leftMap = [10, 35, 50]
const Col = ({ style, children, index }) =>
  <div className={classes.col} style={style}>
    {children}
    <div style={{ left: `${leftMap[index - 1]}%` }} className={classes.colBorder} />
  </div>

export default History



/** WEBPACK FOOTER **
 ** ./src/containers/User/Profile/History.js
 **/